/**
 * A count for display, with thousands separators: 1366 → "1,366". Use for
 * every user-facing count (recipes found, "Showing 1-12 of 1,366", ...).
 */
export const formatCount = (n: number): string => n.toLocaleString('en-US');
